import { render, staticRenderFns } from "./ot-phone-number-field.vue?vue&type=template&id=71b3671e&scoped=true&"
import script from "./ot-phone-number-field.vue?vue&type=script&lang=ts&"
export * from "./ot-phone-number-field.vue?vue&type=script&lang=ts&"
import style0 from "./ot-phone-number-field.vue?vue&type=style&index=0&id=71b3671e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b3671e",
  null
  
)

export default component.exports